
const dynamicParsers = require('./dynamic-parsers')

class Field {
  constructor(field) {
    this.id = field.id || field._id
    this._id = this.id
    this.name = field.name
    this.description = field.description
    this.component = field.component
    this.types = field.types
    this.dataSource = field.dataSource
    this.dynamic = field.dynamic
    this.comparators = field.comparators
    this.options = field.options
    this.isFormField = field.isFormField
  }

  getFieldValue(obj) {
    if (this.dynamic) {
      return dynamicParsers[this.name](obj)
    } else if (this.isFormField) {
      const customField = obj.customFields ? obj.customFields.find(c => c.id === this.name) : undefined
      return customField ? customField.value : undefined
    } else {
      const names = this.name.split('.')
      return names.reduce((previous, current) => {
        if (previous) {
          return previous[current]
        }
      }, obj)
    }
  }

  containsId(obj) {
    const value = this.getFieldValue(obj)

    if (value instanceof Array) {
      return value.some(v => typeof v['id'] !== 'undefined')
    }

    return value && typeof value['id'] !== 'undefined'
  }

  getId(obj) {
    const value = this.getFieldValue(obj)

    if (value instanceof Array) {
      return value.map(v => v['id'])
    }

    return value.id
  }
}

module.exports = Field
